import { yupResolver } from "@hookform/resolvers/yup";
import React, { useState,useEffect } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { submitFormToHubspot } from "../../utils/submitFormToHubspot";
import {
  BasicElementsContainer,
  ErrorMessage,
  FormContainer,
  FormLabel,
  FormTitle,
  InputWrapper,
  PrivacyDisclaimer,
  StyledInput,
  SubmitButton,
  FormHubspotWrapper 
} from "../shared/FormStyles";

const WarrantyForm = () => {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    document.head.appendChild(script);

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "6034553",
          formId: "53da2bd4-7a52-4b8f-ab5f-f754ae281b88",
          target: "#hubspotForm",
        });
      }
    };

    return () => {
      document.head.removeChild(script);
    }
  }, []);

    return (
    <FormHubspotWrapper >
      <div id="hubspotForm" ></div>
    </FormHubspotWrapper>
  );
};

export default WarrantyForm;
